import { createSlice } from '@reduxjs/toolkit';
// utils

// ----------------------------------------------------------------------

const initialState = {
  role_list: [],
  role_group_list: [],
  role_group_list_name: [],
};

const slice = createSlice({
  name: 'staff',
  initialState,
  reducers: {
    initStaff(state, action) {
      return { ...action.payload };
    },
    restStaff() {
      return { ...initialState };
    },
  },
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------

export function initStaffAction(payload) {
  return (dispatch) => {
    try {
      dispatch(slice.actions.initStaff(payload));
    } catch (error) {
      console.log(error);
    }
  };
}

export function restStaffAction() {
  return (dispatch) => {
    try {
      dispatch(slice.actions.restStaff());
    } catch (error) {
      console.log(error);
    }
  };
}
